import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="px-4 md:px-6 py-12">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-1/3">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-white flex items-center justify-center text-lg">
                <i className="ri-film-line"></i>
              </span>
              <span className="font-heading font-bold text-background-50 text-lg">神宫寺奈绪影视内容站</span>
            </div>
            <p className="text-sm text-background-200/80 leading-relaxed max-w-md">
              专注整理神宫寺奈绪相关的电影、电视剧与综艺作品，汇集演艺资料与最新娱乐资讯，为粉丝提供全面、清晰的信息服务。
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 flex-1 gap-8">
            <div>
              <h4 className="text-sm font-medium text-background-50 mb-4">
                <Link to="/category">影视作品</Link>
              </h4>
              <ul className="space-y-2.5 text-sm text-background-200/80">
                <li><Link to="/category" className="hover:text-accent-400 transition-colors">全部作品</Link></li>
                <li><Link to="/category?type=%E7%94%B5%E5%BD%B1" className="hover:text-accent-400 transition-colors">电影</Link></li>
                <li><Link to="/category?type=%E7%94%B5%E8%A7%86%E5%89%A7" className="hover:text-accent-400 transition-colors">电视剧</Link></li>
                <li><Link to="/category?type=%E7%BB%BC%E8%89%BA" className="hover:text-accent-400 transition-colors">综艺</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-medium text-background-50 mb-4">
                <Link to="/news">资讯动态</Link>
              </h4>
              <ul className="space-y-2.5 text-sm text-background-200/80">
                <li><Link to="/news" className="hover:text-accent-400 transition-colors">最新资讯</Link></li>
                <li><Link to="/about" className="hover:text-accent-400 transition-colors">关于本站</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-medium text-background-50 mb-4">联系反馈</h4>
              <ul className="space-y-2.5 text-sm text-background-200/80">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line"></i>
                  <span>contact@nanao-film.demo</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-line"></i>
                  <span>周一至周五 10:00-18:00</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-200/60">
          <p>© 2024 神宫寺奈绪影视内容站 · 本站为演示站点，所有作品与资讯均为虚构示例</p>
          <p>内容仅供参考，不构成任何商业用途</p>
        </div>
      </div>
    </footer>
  );
}